import { ChangeEvent, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { useMobile } from '../Layout/UseResponsive';
import { SettingsService } from '../../services/SettingsService';

export type ChooseFileButtonProps = {
    onFileChange: (file: File | null) => void;
    reset?: number;
    style?: React.CSSProperties | undefined;
    onClick?: () => void;
    onClose?: () => void;
    selectedFileStyleMarginLeft?: React.CSSProperties;
}

export default function ChooseFileButton(props: ChooseFileButtonProps) {
    const settingsService = new SettingsService();
    const [maxFileSize, setMaxFileSize] = useState<number>(50);
    const [maxFileSizeLoaded, setMaxFileSizeLoaded] = useState<boolean>(false);
    const [fileName, setFileName] = useState<string>("");
    const [fileSrc, setFileSrc] = useState<string>("");
    const intl = useIntl();
    const isMobile = useMobile();

    const fetchMaxFileSize = async (): Promise<number> => {
        try {
            const response = await settingsService.GetByName("MaxFileSize");
            if (response.success && response.obj && response.obj.value) {
                const size = parseInt(response.obj.value, 10);
                if (!isNaN(size) && size > 0) {
                    setMaxFileSize(size);
                    return size;
                }
            }
        } catch (error) {
            console.error("Erro ao carregar MaxFileSize:", error);
        } finally {
            setMaxFileSizeLoaded(true);
        }
        return maxFileSize;
    };

    useEffect(() => {
        fetchMaxFileSize();
    }, []);

    const onFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files == null) return;
        const file = e.target.files[0];

        const currentMaxFileSize = maxFileSizeLoaded ? maxFileSize : await fetchMaxFileSize();

        if (file.size / 1024 / 1024 > currentMaxFileSize) {
            Toast.Show("error", `Ficheiros não podem ter mais de ${currentMaxFileSize}MB`);
            removeSelectedFile();
            return;
        }

        setFileName(file.name);
        if (file.type.startsWith("image") || file.type.startsWith("video")) {
            setFileSrc(URL.createObjectURL(file));
        } else {
            setFileSrc("");
        }
        props.onFileChange(file);
    }

    const removeSelectedFile = () => {
        setFileName("");
        setFileSrc("");
        
        const inputElement = document.getElementById("files") as HTMLInputElement;

        if (props.onClose) {
            props.onClose();
        }

        if (inputElement != null) {
            inputElement.value = "";
        }
        props.onFileChange(null);
    }

    useEffect(() => {
        if (typeof props.reset !== 'undefined' && props.reset > 0) {
            removeSelectedFile();
        }
    }, [props.reset]);

    return (
        <div>
            <Row style={{ display: "flex", alignItems: "flex-start" }}>
                <Col xl={3} style={{ "margin": "10px 0px" }}>
                    <label htmlFor="files" style={{ "marginLeft": "0px", textAlign: "center", padding: '12px', ...props.style }} className="button">
                        {intl.formatMessage({ id: "Common.ChooseFileButton.Label" })}
                    </label>
                </Col>
                <Col xl={12} style={{ margin: "0px" }}>
                    <input
                        id="files"
                        accept="image/*,.pdf,video/*,.mkv,video/x-matroska,video/webm,.xls,.xlsx"
                        style={{ visibility: "hidden" }}
                        onChange={onFileChange}
                        type="file"
                    />
                </Col>
                {fileName && (
                    <Col xl={12} style={{ margin: "10px 0", ...props.selectedFileStyleMarginLeft, paddingRight: "10px" }}>
                        <div className='inputFileShow' style={{ position: 'relative' }}>
                            <label className='inputFileClearFile' onClick={removeSelectedFile} style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }}>X</label>
                            <div className="inputFileShowFileName" style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', flexWrap: 'wrap' }}>
                                <label style={{ marginRight: "auto" }}>
                                    <span style={{ fontWeight: 900 }}>
                                        {intl.formatMessage({ id: "Common.ChooseFileButton.SelectedFile" })}
                                    </span>
                                    {isMobile ? (
                                        <br />
                                    ) : (
                                        <span> </span>
                                    )}
                                    {fileName}
                                </label>
                            </div>
                            {fileSrc && (
                                <Row style={{ margin: "0px" }}>
                                    <Col xl={12} style={{ margin: "0px" }}>
                                        <img alt='Ficheiro Escolhido' className='inputFilePreview' src={fileSrc} />
                                    </Col>
                                </Row>
                            )}
                        </div>
                    </Col>
                )}
            </Row>
        </div>
    );
}